var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneProp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6388_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.877 419.718C428.544 406.241 421.322 394.2 410.058 386.686L333.696 335.783C315.869 323.903 292.036 326.305 276.904 341.408L252.5 366.017C246.948 367.951 221.27 357.067 188.208 323.991C155.132 290.9 144.395 265.441 145.801 260.373L170.835 235.339C185.952 220.222 188.325 196.33 176.46 178.547L125.557 102.185C118.042 90.92 106.001 83.699 92.5248 82.366C79.0188 81.018 65.8648 85.764 56.2988 95.33L18.5348 133.094C-33.2182 184.847 34.1798 298.577 123.916 388.328C184.922 449.334 318.424 554.507 379.15 493.709L416.914 455.945C426.479 446.393 431.21 433.18 429.877 419.718Z",
    fill: "url(#paint0_linear_6388_144)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.523 0C279.232 0 272.523 6.709 272.523 15C272.523 23.291 279.232 30 287.523 30C395.043 30 482.523 117.48 482.523 225C482.523 233.291 489.232 240 497.523 240C505.814 240 512.523 233.291 512.523 225C512.523 100.928 411.595 0 287.523 0ZM287.523 60C279.232 60 272.523 66.709 272.523 75C272.523 83.291 279.232 90 287.523 90C361.966 90 422.523 150.557 422.523 225C422.523 233.291 429.232 240 437.523 240C445.814 240 452.523 233.291 452.523 225C452.523 134.019 378.504 60 287.523 60ZM287.523 120C279.232 120 272.523 126.709 272.523 135C272.523 143.291 279.232 150 287.523 150C328.876 150 362.523 183.647 362.523 225C362.523 233.291 369.232 240 377.523 240C385.814 240 392.523 233.291 392.523 225C392.523 167.109 345.414 120 287.523 120ZM287.523 180C279.232 180 272.523 186.709 272.523 195C272.523 203.291 279.232 210 287.523 210C295.799 210 302.523 216.724 302.523 225C302.523 233.291 309.232 240 317.523 240C325.814 240 332.523 233.291 332.523 225C332.523 200.186 312.337 180 287.523 180Z",
    fill: "url(#paint1_linear_6388_144)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6388_144",
    x1: 215.311,
    y1: 511.999,
    x2: 215.311,
    y2: 82.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6388_144",
    x1: 392.523,
    y1: 240,
    x2: 392.523,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6388_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.523438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneProp);
export default __webpack_public_path__ + "static/media/phone-prop.b8d28e6625369be3f2224ce0fd7e0d34.svg";
export { ForwardRef as ReactComponent };